// @ts-nocheck

import { createSlice, PayloadAction, createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { BASE_URL } from "../Constants/BaseUrl";

import { toast } from "react-toastify";

import axios from "axios";
import { logoutUser, updateUserProfilePicture } from "./userSlice";

// Define the structure of a Post
type Post = {
  id: string;
  content: string;
  videoUrl: string | null;
  imageUrl: string | null;
  createdAt: string;
  liked: boolean;
  username: string;
  profile_picture: string;
  first_name: string;
  last_name: string;
};

interface PostsState {
  userPosts: Post[];
  allPosts: Post[];
  postBySports: Post[];

  loading: boolean;
  error: string | null;
  searchResults: {
    posts: any[];
    users: any[];
  };
  searchLoading: boolean;
  userPublicProfile: any | null; // Add this line
  ownerPublicProfile: any | null;
  coachOwnProfile: any | null;
  coachPublicProfile: any | null;
  allPostsApiResponse: any | null;
}

const initialState: PostsState = {
  userPosts: [],
  allPosts: [],
  postBySports: [],
  loading: false,
  error: null,
  searchResults: {
    posts: [],
    users: [],
  },
  searchLoading: false,
  userPublicProfile: null, // Add this line
  ownerPublicProfile: null,
  coachOwnProfile: null,
  coachPublicProfile: null,
  allPostsApiResponse: null,
};

export const fetchPostsBySport = createAsyncThunk<
  Post[], // Return type
  string, // sport_id is passed in as the argument
  { state: RootState; rejectValue: string }
>("posts/fetchPostsBySport", async (sport_id, thunkApi) => {
  try {
    const state = thunkApi.getState();
    const token = state.user.token;

    const response = await fetch(`${BASE_URL}post/all?sport_id=${sport_id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || "Failed to fetch filtered posts");
    }

    const data = await response.json();

    console.log(data.data, "Please check the data", sport_id);

    if (!data.success || !Array.isArray(data.data.data)) {
      throw new Error("Invalid response format");
    }
    if (data?.error === "Invalid token") {
      alert("Session Expired!");
      thunkApi.dispatch(logoutUser());
    }

    return data.data.data; // or transform the posts if needed
  } catch (error: any) {
    return thunkApi.rejectWithValue(error.message || "Unknown error");
  }
});

export const reportPost = createAsyncThunk<
  void,
  { postId: number; userId: number; reason: string },
  { state: RootState; rejectValue: string }
>("posts/reportPost", async ({ postId, userId, reason }, thunkApi) => {
  try {
    const state = thunkApi.getState();
    const token = state.user.token;

    const formData = new FormData();
    formData.append("post_id", postId.toString());
    formData.append("reported_user_id", userId.toString());
    formData.append("reason", reason);

    const response = await fetch(`${BASE_URL}/post/report`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token || ""}`,
      },
      body: formData,
    });

    // console.log('report response: ', JSON.stringify(response, null, 2));

    const data = await response.json();
    console.log("report response: ", data);

    if (!response.ok) {
      throw new Error(data.error || "Failed to submit report");
    }

    if (data.error === "Invalid token") {
      alert("Session Expired!");
      thunkApi.dispatch(logoutUser());
    }

    return;
  } catch (error: any) {
    return thunkApi.rejectWithValue(error.message || "Failed to submit report");
  }
});

export const deletePost = createAsyncThunk<
  string, // Return type (post ID)
  string, // Argument type (post ID)
  { state: RootState; rejectValue: string }
>("posts/deletePost", (postId, thunkApi) => {
  const state = thunkApi.getState();
  const token = state.user.token;

  console.log(postId, "token", token);

  const formData = new FormData();
  formData.append("post_id", postId);

  return axios
    .post(`${BASE_URL}post/delete`, formData, {
      headers: {
        Authorization: `Bearer ${token || ""}`,
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      console.log(response.data, "Testing");
      return postId; // Return the ID to remove it from state
    })
    .catch((error) => {
      const message =
        error.response?.data?.message ||
        error.message ||
        "Failed to delete post";
      return thunkApi.rejectWithValue(message);
    });
});

export const fetchUserPublicProfile = createAsyncThunk<
  any, // or a more specific type if available
  string, // user ID
  { state: RootState; rejectValue: string }
>("posts/fetchUserPublicProfile", async (userId, thunkApi) => {
  try {
    const state = thunkApi.getState();
    const token = state.user.token;

    const response = await axios.get(`${BASE_URL}athlete/get/?id=${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log(JSON.stringify(response.data.data), "faraz");

    if (response?.data?.error === "Invalid token") {
      alert("Session Expired!");
      thunkApi.dispatch(logoutUser());
    }

    return response.data.data; // this is the user profile
  } catch (error: any) {
    return thunkApi.rejectWithValue(error.message || "Failed to fetch profile");
  }
});

export const fetchUserOwnerProfile = createAsyncThunk<
  any, // or a more specific type if available
  string, // user ID
  { state: RootState; rejectValue: string }
>("posts/fetchUserOwnerProfile", async (userId, thunkApi) => {
  try {
    const state = thunkApi.getState();
    const token = state.user.token;

    const response = await axios.get(`${BASE_URL}athlete/get/?id=${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log(JSON.stringify(response.data.data), "faraz");

    if (response?.data?.error === "Invalid token") {
      alert("Session Expired!");
      thunkApi.dispatch(logoutUser());
    }

    return response.data.data; // this is the user profile
  } catch (error: any) {
    return thunkApi.rejectWithValue(error.message || "Failed to fetch profile");
  }
});

export const fetchCoachPublicProfile = createAsyncThunk<
  any, // or a more specific type if available
  string, // user ID
  { state: RootState; rejectValue: string }
>("posts/fetchCoachPublicProfile", async (userId, thunkApi) => {
  try {
    const state = thunkApi.getState();
    const token = state.user.token;

    const response = await axios.get(`${BASE_URL}coach/get/?id=${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response?.data?.error === "Invalid token") {
      alert("Session Expired!");
      thunkApi.dispatch(logoutUser());
    }

    return response.data.data; // this is the user profile
  } catch (error: any) {
    return thunkApi.rejectWithValue(error.message || "Failed to fetch profile");
  }
});

export const fetchCoachOwnerProfile = createAsyncThunk<
  any, // or a more specific type if available
  string, // user ID
  { state: RootState; rejectValue: string }
>("posts/fetchCoachOwnerProfile", async (userId, thunkApi) => {
  try {
    const state = thunkApi.getState();
    const token = state.user.token;

    const response = await axios.get(`${BASE_URL}coach/get/?id=${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response?.data?.error === "Invalid token") {
      alert("Session Expired!");
      thunkApi.dispatch(logoutUser());
    }

    return response.data.data; // this is the user profile
  } catch (error: any) {
    return thunkApi.rejectWithValue(error.message || "Failed to fetch profile");
  }
});

export const updateCoachInfo = createAsyncThunk(
  "user/updateCoachInfo",
  async (
    {
      username,
      first_name,
      last_name,
      sport_id,
      college,
    }: {
      username: string;
      first_name: string;
      last_name: string;
      sport_id: string;
      college: string;
    },
    thunkAPI
  ) => {
    try {
      const state = thunkAPI.getState() as any;
      const token = state.user.token;

      const formData = new FormData();
      formData.append("username", username);
      formData.append("first_name", first_name);
      formData.append("last_name", last_name);
      formData.append("sport_id", sport_id);
      formData.append("college", college);

      const response = await axios.post(
        `${BASE_URL}coach/update-profile`,
        formData,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.data.success) {
        throw new Error(response.data.message || "Failed to save athlete info");
      }

      // toast("Athletic info updated successfully!");
      if (response?.data?.error === "Invalid token") {
        alert("Session Expired!");
        thunkApi.dispatch(logoutUser());
      }

      // Dispatch only athlete_info to update ownerPublicProfile.athlete_info
      thunkAPI.dispatch(
        updateCoachProfile(response.data.data?.coach_info || null)
      );

      return; // optionally return nothing
    } catch (error: any) {
      showMessage({
        message: error.response?.data?.message || error.message,
        type: "danger",
      });
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

// 🔄 Async Thunk: Create a new user post
// export const createUserPost = createAsyncThunk<
//   Post,
//   { caption: string; mediaFile: File; mediaType: "image" | "video" },
//   { state: RootState; rejectValue: string }
// >(
//   "posts/createUserPost",
//   async ({ caption, mediaFile, mediaType }, thunkApi) => {
//     try {
//       const state = thunkApi.getState();
//       const token = state.user.token;

//       const formData = new FormData();
//       formData.append("content", caption);
//       if (mediaType === "image") {
//         formData.append("image", mediaFile, mediaFile?.name);
//       } else {
//         formData.append("video", mediaFile, mediaFile?.name);
//       }

//       const response = await fetch(`${BASE_URL}post/create`, {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${token || ""}`,
//           "Content-Type": "multipart/form-data",
//         },
//         body: formData,
//       });

//       if (!response.ok) {
//         const errorText = await response.text();
//         throw new Error(errorText || "Failed to create post");
//       }

//       const createdPostData = await response.json();

//       const createdPost: Post = {
//         id: createdPostData.data.post_id.toString(),
//         content: createdPostData.data.content,
//         videoUrl: createdPostData.data.video_url || null,
//         imageUrl: createdPostData.data.image_url || null,
//         createdAt: createdPostData.data.created_at,
//         liked: false,
//       };
//       await thunkApi.dispatch(fetchAllPublicPosts());
//       return createdPost;
//     } catch (error: any) {
//       return thunkApi.rejectWithValue(error.message || "Unknown error");
//     }
//   }
// );

export const createUserPost = createAsyncThunk<
  Post,
  {
    caption: string;
    mediaFile: File;
    mediaType: "image" | "video";
    tempId: string;
    onProgress?: (progress: number) => void;
  },
  { state: RootState; rejectValue: string }
>(
  "posts/createUserPost",
  async ({ caption, mediaFile, mediaType, tempId, onProgress }, thunkApi) => {
    try {
      const state = thunkApi.getState();
      const token = state.user.token;

      const formData = new FormData();
      formData.append("content", caption);
      if (mediaType === "image") {
        formData.append("image", mediaFile, mediaFile?.name);
      } else {
        formData.append("video", mediaFile, mediaFile?.name);
      }

      const response = await axios.post(`${BASE_URL}post/create`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: (progressEvent: ProgressEvent) => {
          const progress = Math.round(
            (progressEvent.loaded * 100) / (progressEvent.total || 1)
          );
          if (onProgress) onProgress(progress);

          // Or you can dispatch Redux update:
          thunkApi.dispatch(updateUploadProgress({ tempId, progress }));
        },
      });

      if (response?.data?.error === "Invalid token") {
        alert("Session Expired!");
        thunkApi.dispatch(logoutUser());
      }

      thunkApi.dispatch(finishUploadingPost(tempId));

      thunkApi.dispatch(updateAllPost(response.data.data));
      // toast.success("Post created successfully!", {
      //   position: "top-right",
      //   autoClose: 3000,
      // });

      console.log(response.data, "TEStingCreatedPostIten");
      return response.data.data;
    } catch (error: any) {
      console.log(error, "TEstingErororCreate");
      return thunkApi.rejectWithValue(error.message || "Upload failed");
    }
  }
);

export const fetchUsersBySport = createAsyncThunk<
  Post[],
  string,
  { state: RootState; rejectValue: string }
>("posts/fetchUsersBySport", async (sport_id, thunkApi) => {
  try {
    const state = thunkApi.getState();
    const token = state.user.token;

    const response = await fetch(
      `${BASE_URL}user/get-users-by-sport/?sport_id=${sport_id}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    console.log(response, "TestingREsponse");

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || "Failed to fetch filtered posts");
    }

    const data = await response.json();

    if (!data.success || !Array.isArray(data.data)) {
      throw new Error("Invalid response format");
    }
    if (data?.error === "Invalid token") {
      alert("Session Expired!");
      thunkApi.dispatch(logoutUser());
    }

    console.log(data.data, "Please check the data", sport_id);

    return data.data; // or transform the posts if needed
  } catch (error: any) {
    return thunkApi.rejectWithValue(error.message || "Unknown error");
  }
});

export const updateAthleticInfo = createAsyncThunk(
  "user/saveAthleticInfo",
  async (
    {
      athlete_id,
      first_name,
      last_name,
      dob,
      gender,
      current_school,
      sport_id,
      position,
      school_year,
      division,
      height,
      weight,
    }: {
      athlete_id: string;
      first_name: string;
      last_name: string;
      dob: string;
      gender: string;
      division: string;
      current_school: string;
      sport_id: string;
      position: string;
      school_year: string;
      height: string;
      weight: string;
    },
    thunkAPI
  ) => {
    try {
      const state = thunkAPI.getState() as any;
      const token = state.user.token;

      const formData = new FormData();
      formData.append("athlete_id", athlete_id);
      formData.append("first_name", first_name);
      formData.append("last_name", last_name);
      formData.append("dob", dob);
      formData.append("division", division);
      formData.append("gender", gender);
      formData.append("current_school", current_school);
      formData.append("sport_id", sport_id);
      formData.append("position", position);
      formData.append("school_year", school_year);
      formData.append("height", height);
      formData.append("weight", weight);

      const response = await axios.post(
        `${BASE_URL}athlete/update-athletic-info`,
        formData,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.data.success) {
        throw new Error(response.data.message || "Failed to save athlete info");
      }

      // showMessage({
      //   message: "Athletic info updated successfully!",
      //   type: "success",
      // });

      if (response?.data?.error === "Invalid token") {
        alert("Session Expired!");
        thunkApi.dispatch(logoutUser());
      }

      // Dispatch only athlete_info to update ownerPublicProfile.athlete_info
      thunkAPI.dispatch(updateAthleteInfoSave(response.data.data || null));

      return; // optionally return nothing
    } catch (error: any) {
      // showMessage({
      //   message: error.response?.data?.message || error.message,
      //   type: "danger",
      // });
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const searchPostsAndUsers = createAsyncThunk<
  { posts: any[]; users: any[] },
  string,
  { state: RootState; rejectValue: string }
>("posts/searchPostsAndUsers", async (keyword, thunkApi) => {
  try {
    const state = thunkApi.getState();
    const token = state.user.token;

    const response = await fetch(
      `${BASE_URL}search/query/?keyword=${keyword}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token || ""}`,
          "Content-Type": "application/json",
        },
      }
    );

    // console.log({
    //   Authorization: `Bearer ${token || ''}`,
    //   'Content-Type': 'application/json',
    //   url: `${BASE_URL}search/query/?keyword=${keyword}`,
    // });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || "Search failed");
    }

    const data = await response.json();
    console.log(data, "ResponseFromSearchApi====");
    if (data.error === "Invalid token") {
      alert("Session Expired!");
      thunkApi.dispatch(logoutUser());
    }

    return {
      posts: data.data.posts.data,
      users: data.data.users.data,
    };
  } catch (error: any) {
    return thunkApi.rejectWithValue(error.message || "Unknown error");
  }
});
export const updateProfilePicture = createAsyncThunk(
  "user/updateProfilePicture",
  async (profilePicture: File, thunkAPI) => {
    try {
      const state = thunkAPI.getState();
      const token = state.user.token;

      const formData = new FormData();
      formData.append("profile_picture", profilePicture);

      const response = await fetch(`${BASE_URL}/auth/update-dp`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
          // Do not set Content-Type for FormData; browser handles it
        },
        body: formData,
      });

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.message || "Failed to update profile picture");
      }

      if (data?.error === "Invalid token") {
        alert("Session Expired!");
        thunkAPI.dispatch(logoutUser());
      }

      try {
        const userDataString = localStorage.getItem("user");

        if (!userDataString) {
          throw new Error("No user data found in storage");
        }

        const userData = JSON.parse(userDataString);
        userData.profile_picture = data.updated_dp;
        localStorage.setItem("user", JSON.stringify(userData));

        console.log("Profile picture updated in localStorage");
      } catch (error) {
        console.error("Error updating user data in localStorage:", error);
      }

      thunkAPI.dispatch(updateProfilePictureSave(data.updated_dp));
      thunkAPI.dispatch(updateUserProfilePicture(data.updated_dp));

      // toast.success("Profile picture updated successfully!");

      return data.data;
    } catch (error: any) {
      console.error("Error updating profile picture:", error.message, error);
      const message = error.message || "Something went wrong";
      toast.error(message);
      return thunkAPI.rejectWithValue(message);
    }
  }
);
// 🔄 Async Thunk: Fetch posts by a specific user
export const fetchUserPosts = createAsyncThunk<
  Post[],
  string,
  { state: RootState; rejectValue: string }
>("posts/fetchUserPosts", async (userId, thunkApi) => {
  try {
    const state = thunkApi.getState();
    const token = state.user.token;

    const response = await fetch(`${BASE_URL}post/by-user/?id=${userId}`, {
      headers: {
        Authorization: `Bearer ${token || ""}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      const errorText = await response.text();

      console.log(errorText);
      throw new Error(errorText || "Failed to fetch posts");
    }

    const data = await response.json();

    console.log(data, "Testing");

    if (!data.success || !Array.isArray(data.data)) {
      throw new Error("Invalid response format");
    }
    if (data?.error === "Invalid token") {
      alert("Session Expired!");
      thunkAPI.dispatch(logoutUser());
    }

    // const posts: Post[] = data.data.length
    //   ? data.data.map((post: any) => ({
    //       id: post.post_id.toString(),
    //       content: post.content,
    //       user_id: post.user_id,
    //       videoUrl: post.video_url || null,
    //       imageUrl: post.image_url || null,
    //       createdAt: post.created_at,
    //       liked: post.liked,
    //       like_count: post.like_count,
    //       username: post.username,
    //       like_count: post.like_count,
    //       first_name: post.first_name,
    //       last_name: post.last_name,
    //       profile_picture: BASE_URL + post.profile_picture,
    //     }))
    //   : [];

    return data.data;
  } catch (error: any) {
    return thunkApi.rejectWithValue(error.message || "Unknown error");
  }
});

// 🔄 Async Thunk: Fetch all public posts
export const fetchAllPublicPosts = createAsyncThunk<
  any[] | null, // return raw posts or null
  void,
  { state: RootState; rejectValue: string }
>("posts/fetchAllPublicPosts", async (_, thunkApi) => {
  try {
    const state = thunkApi.getState();
    const token = state.user.token;

    const response = await fetch(`${BASE_URL}post/all`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();
    console.log("fetch all post response: ", data);

    // ALWAYS save the raw API response – success or not
    thunkApi.dispatch(setAllPostsApiResponse(data));

    // Handle session expiry
    if (data?.error === "Invalid token") {
      alert("Session Expired!");
      thunkApi.dispatch(logoutUser());
      return thunkApi.rejectWithValue("Session expired");
    }

    // If profile is private → we still want the response saved!
    // Just return null (or empty array) for the posts list
    if (!data.success) {
      return null; // no posts to show
    }

    // Validate posts array
    if (!Array.isArray(data.data.data)) {
      console.error("data.data.data is not an array", data);
      return null;
    }

    // Success → return raw posts
    return data.data.data;
  } catch (error: any) {
    // Only network/parsing errors come here
    console.error("Network/parsing error:", error);
    thunkApi.dispatch(setAllPostsApiResponse(null));
    return thunkApi.rejectWithValue("Network error");
  }
});

// 🔄 Async Thunk: Like a post
export const likePost = createAsyncThunk<
  string,
  string,
  { state: RootState; rejectValue: string }
>("posts/likePost", async (postId, thunkApi) => {
  try {
    const state = thunkApi.getState();
    const token = state.user.token;

    const response = await fetch(`${BASE_URL}post/like`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token || ""}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ post_id: postId }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || "Failed to like post");
    }

    return postId;
  } catch (error: any) {
    return thunkApi.rejectWithValue(error.message || "Unknown error");
  }
});

// 🧩 Slice
export const postsSlice = createSlice({
  name: "posts",
  initialState,
  reducers: {
    removeAchievementFromProfile: (state, action) => {
      if (state.ownerPublicProfile?.athlete_achievements) {
        state.ownerPublicProfile.athlete_achievements =
          state.ownerPublicProfile.athlete_achievements.filter(
            (achievement) => achievement.id !== action.payload
          );
      }
    },
    addAchievementToProfile: (state, action) => {
      if (state.ownerPublicProfile?.athlete_achievements) {
        state.ownerPublicProfile.athlete_achievements.push(action.payload);
      } else {
        state.ownerPublicProfile.athlete_achievements = [action.payload];
      }
    },
    startUploadingPost(state, action: PayloadAction<UploadingPost>) {
      state?.uploadingPosts?.push(action.payload);
    },
    setAllPostsApiResponse: (state, action: PayloadAction<any>) => {
      state.allPostsApiResponse = action.payload;
    },

    clearAllPostsApiResponse: (state) => {
      state.allPostsApiResponse = null;
    },
    updateUploadProgress(
      state,
      action: PayloadAction<{ tempId: string; progress: number }>
    ) {
      const upload = state?.uploadingPosts?.find(
        (u) => u.tempId === action.payload.tempId
      );
      if (upload) {
        upload.progress = action.payload.progress;
      }
    },
    finishUploadingPost(
      state,
      action: PayloadAction<{ tempId: string; post: Post | null }>
    ) {
      const { tempId } = action.payload;

      console.log(tempId, "TestingTempid");
      state.uploadingPosts = state?.uploadingPosts?.filter(
        (post) => post.tempId !== tempId
      );
    },
    updateAllPost: (state, action: PayloadAction<Post | Post[]>) => {
      const newPosts = Array.isArray(action.payload)
        ? action.payload
        : [action.payload];
      state.allPosts = [...newPosts, ...state.allPosts];
    },
    setUserPosts: (state, action: PayloadAction<Post[]>) => {
      state.userPosts = action.payload;
    },
    clearSearchResults: (state) => {
      state.searchResults = {
        posts: [],
        users: [],
      };
      state.loading = false;
    },
    setAllPosts: (state, action: PayloadAction<Post[]>) => {
      state.allPosts = action.payload;
    },
    toggleLike: (state, action: PayloadAction<string>) => {
      const post = [...state.userPosts, ...state.allPosts].find(
        (p) => p.id === action.payload
      );
      if (post) post.liked = !post.liked;
    },
    updateProfilePictureSave(state, action: PayloadAction<string>) {
      console.log(action.payload, "Updated profile picture");

      if (state.ownerPublicProfile) {
        state.ownerPublicProfile.profile_picture = action.payload;
      }

      if (state.coachOwnProfile) {
        state.coachOwnProfile.profile_picture = action.payload;
      }
    },
    updateCoachProfile(state, action: PayloadAction<any>) {
      console.log(action.payload, "Updatethisshit");
      if (state.coachOwnProfile) {
        state.coachOwnProfile.coach_info = action.payload;
      }
    },
    updateAthleteInfoSave(state, action: PayloadAction<any>) {
      console.log(action.payload, "Updatethisshit");
      if (!state.ownerPublicProfile) {
        state.ownerPublicProfile = {}; // initialize if null
      }

      state.ownerPublicProfile.athlete_info = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(deletePost.fulfilled, (state, action) => {
        const deletedPostId = action.payload;

        state.userPosts = state.userPosts.filter(
          (post) => post.id !== deletedPostId
        );
        state.allPosts = state.allPosts.filter(
          (post) => post.id !== deletedPostId
        );

        // state.searchResults.posts.findIndex(
        //   p => String(p.post_id) === String(deletedPostId),
        // );

        toast("Post deleted successfully.");
      })
      .addCase(deletePost.rejected, (state, action) => {
        toast(`Failed to delete post`);
      });

    builder
      .addCase(fetchUserOwnerProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserOwnerProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.ownerPublicProfile = action.payload;
      })
      .addCase(fetchUserOwnerProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch public profile";

        toast(state.error);
      });
    builder
      .addCase(fetchUserPublicProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserPublicProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.userPublicProfile = action.payload;
      })
      .addCase(fetchUserPublicProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch public profile";

        toast(state.error);
      });
    builder
      .addCase(fetchCoachPublicProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCoachPublicProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.coachPublicProfile = action.payload;
      })
      .addCase(fetchCoachPublicProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch coach public profile";
        toast(state.error);
      });
    builder
      .addCase(fetchCoachOwnerProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCoachOwnerProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.coachOwnProfile = action.payload;
      })
      .addCase(fetchCoachOwnerProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch public profile";
        toast(state.error);
      });
    builder
      .addCase(searchPostsAndUsers.pending, (state) => {
        state.searchLoading = true;
        state.error = null;
      })
      .addCase(searchPostsAndUsers.fulfilled, (state, action) => {
        state.searchLoading = false;
        state.searchResults.posts = action.payload.posts;
        state.searchResults.users = action.payload.users;
      })
      .addCase(searchPostsAndUsers.rejected, (state, action) => {
        state.searchLoading = false;
        state.error = action.payload || "Search failed";

        toast("Search request failed");
      });

    builder
      .addCase(fetchPostsBySport.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPostsBySport.fulfilled, (state, action) => {
        state.loading = false;
        state.postBySports = action.payload;
      })
      .addCase(fetchPostsBySport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch public posts";
      });

    // 🟢 Like Post (updated logic)
    // builder
    //   .addCase(likePost.fulfilled, (state, action) => {
    //     const postId = action.payload;

    //     console.log(action.payload, "Payload");

    //     const toggleLike = (post: any) => {
    //       const wasLiked = post.liked;
    //       post.liked = !wasLiked;
    //       post.like_count = Math.max(
    //         0,
    //         (post.like_count || 0) + (wasLiked ? -1 : 1)
    //       );
    //     };

    //     if (state.userPublicProfile && state.userPublicProfile.posts) {
    //       const userProfilePostIndex = state.userPublicProfile.posts.findIndex(
    //         (p) => p.post_id === postId
    //       );
    //       if (userProfilePostIndex !== -1) {
    //         toggleLike(state.userPublicProfile.posts[userProfilePostIndex]);
    //       }
    //     }

    //     const allPostIndex = state.allPosts.findIndex(
    //       (p) => p.post_id === postId
    //     );
    //     if (allPostIndex !== -1) {
    //       toggleLike(state.allPosts[allPostIndex]);
    //     }

    //     const userPostIndex = state.userPosts.findIndex(
    //       (p) => p.post_id === postId
    //     );

    //     console.log(
    //       userPostIndex,
    //       JSON.stringify(state.userPosts[userPostIndex])
    //     );
    //     if (userPostIndex !== -1) {
    //       toggleLike(state.userPosts[userPostIndex]);
    //     }

    //     const searchResultIndex = state.searchResults.posts.findIndex(
    //       (p) => String(p.post_id) === String(postId)
    //     );

    //     if (searchResultIndex !== -1) {
    //       toggleLike(state.searchResults.posts[searchResultIndex]); // ✅ Fixed here
    //     }
    //   })
    // 🟢 Like Post (updated logic)
    builder
      .addCase(likePost.fulfilled, (state, action) => {
        const postId = action.payload;

        console.log(action.payload, "Payload");

        const toggleLike = (post: any) => {
          console.log(post, "postpostpost");
          const wasLiked = post.liked;
          post.liked = !wasLiked;
          post.like_count = Math.max(
            0,
            (post.like_count || 0) + (wasLiked ? -1 : 1)
          );
        };

        if (state.userPublicProfile && state.userPublicProfile.posts) {
          const userProfilePostIndex = state.userPublicProfile.posts.findIndex(
            (p) => p.post_id === postId
          );
          if (userProfilePostIndex !== -1) {
            toggleLike(state.userPublicProfile.posts[userProfilePostIndex]);
          }
        }

        if (state.coachPublicProfile && state.coachPublicProfile.posts) {
          const userProfilePostIndex = state.coachPublicProfile.posts.findIndex(
            (p) => p.post_id === postId
          );
          if (userProfilePostIndex !== -1) {
            toggleLike(state.coachPublicProfile.posts[userProfilePostIndex]);
          }
        }

        if (state.coachOwnProfile && state.coachOwnProfile.posts) {
          const userProfilePostIndex = state.coachOwnProfile.posts.findIndex(
            (p) => p.post_id === postId
          );
          if (userProfilePostIndex !== -1) {
            toggleLike(state.coachOwnProfile.posts[userProfilePostIndex]);
          }
        }

        const allpostforSportsId = state.postBySports.findIndex(
          (p) => p.post_id === postId
        );

        console.log(
          allpostforSportsId,
          "allpostforSportsIdallpostforSportsIdallpostforSportsId",
          state.postBySports[allpostforSportsId],
          postId
        );
        if (allpostforSportsId !== -1) {
          toggleLike(state.postBySports[allpostforSportsId]);
        }

        const allPostIndex = state.allPosts.findIndex(
          (p) => p.post_id === postId
        );
        if (allPostIndex !== -1) {
          toggleLike(state.allPosts[allPostIndex]);
        }

        const userPostIndex = state.userPosts.findIndex(
          (p) => p.post_id === postId
        );

        console.log(
          userPostIndex,
          JSON.stringify(state.userPosts[userPostIndex])
        );
        if (userPostIndex !== -1) {
          toggleLike(state.userPosts[userPostIndex]);
        }

        const searchResultIndex = state.searchResults.posts.findIndex(
          (p) => String(p.post_id) === String(postId)
        );

        if (searchResultIndex !== -1) {
          toggleLike(state.searchResults.posts[searchResultIndex]); // ✅ Fixed here
        }
      })

      .addCase(likePost.rejected, (state, action) => {
        toast("Failed to like post");
      });

    builder
      .addCase(fetchUserPosts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserPosts.fulfilled, (state, action) => {
        state.loading = false;
        state.userPosts = action.payload;
      })
      .addCase(fetchUserPosts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch posts";
      });

    builder
      .addCase(fetchAllPublicPosts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllPublicPosts.fulfilled, (state, action) => {
        state.loading = false;
        state.allPosts = action.payload;
      })
      .addCase(fetchAllPublicPosts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch public posts";
      });

    builder
      .addCase(fetchUsersBySport.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUsersBySport.fulfilled, (state, action) => {
        state.loading = false;
        state.userBySports = action.payload;
      })
      .addCase(fetchUsersBySport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch public posts";
      });

    builder
      .addCase(reportPost.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(reportPost.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(reportPost.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to submit report";
      });

    builder
      .addCase(createUserPost.pending, (state) => {
        // state.loading = true;
        state.error = null;
      })
      .addCase(createUserPost.fulfilled, (state, action) => {
        state.loading = false;
        state.userPosts.unshift(action.payload);

        if (state.coachOwnProfile) {
          state.coachOwnProfile.posts.unshift(action.payload);
        }
        // state.allPosts.unshift(action.payload); // <-- also add to allPosts
      })
      .addCase(createUserPost.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to create post";
      });
  },
});

// 🧱 Exports
export const {
  setUserPosts,
  setAllPosts,
  toggleLike,
  addAchievementToProfile,
  removeAchievementFromProfile,
  updateProfilePictureSave,
  updateAthleteInfoSave,
  clearSearchResults,
  updateCoachProfile,
  startUploadingPost,
  updateUploadProgress,
  finishUploadingPost,
  updateAllPost,
  setAllPostsApiResponse,
  clearAllPostsApiResponse,
} = postsSlice.actions;
export default postsSlice.reducer;
